var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.className }, [
    _c(
      "div",
      {
        ref: "continueModal",
        staticClass: "reveal",
        attrs: { id: "projectControlLeaveModal", "data-reveal": "" },
      },
      [
        _c(
          "button",
          {
            staticClass: "close-button",
            attrs: {
              id: "project_control_confirm_close",
              type: "button",
              "aria-label": "Close modal",
            },
            on: {
              click: function ($event) {
                return _vm.closeModal()
              },
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tender-confirm clearfix" }, [
          _c("p", { staticClass: "msg_hint" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.warnMessage || _vm.$t("warn.leave.lost")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tender-confirm-button-bar row align-right nav_btn",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: {
                    id: "project_control_confirm_discard",
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.continueTo()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.discardAndContinue")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: { id: "project_control_confirm_save", type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.saveAndContinue()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.saveAndContinue")) +
                      "\n        "
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }